import validate from '../../../validations';
import { saveApplication, debounce } from './../../../utilities';
import { DEBOUNCE_TIME } from './../../../constants';
import { fillInAddress, maskPhoneNum, maskLetters } from './../../../utils';
import { geocodeByPlaceId } from 'react-google-places-autocomplete';
import { replaceDoubleSpaceToSingle } from 'utils';
import { US_STATES } from "utils/statesCodeOptions";

export default {
    refreshOn: ({ currentResidency }) => [currentResidency],
    init: (fullState, stateManager, internalStateSetter) => {
        debounce(() => saveApplication(stateManager), DEBOUNCE_TIME)

    },
    'Landlord.Wrapper.Location': ({ value, resourceObj: currentResidency }, stateManager) => {
        const { place_id } = value
        geocodeByPlaceId(place_id)
            .then(r => {
                const address = fillInAddress(r[0].address_components);
                const selectedUSState = US_STATES.find(s => s.id === address?.state)
                if(!selectedUSState) {
                    address["state"] = ""
                }
                
                const updatedCurrentResidency = { ...currentResidency, address, hasError: false, addressError: { addressError: '', cityError: '', stateError: '', zipError: ''} }
                stateManager.setCurrentResidency(updatedCurrentResidency)
                validate(3000)

            })
            .catch(e => { 
            })
    },
    'Landlord.Wrapper.AddressDetails.City': ({ currentResidency, value }, stateManager) => {
        
        const maskedValue = maskLetters(value)
        const updatedCurrentResidency = { ...currentResidency, address: { ...currentResidency.address, city: maskedValue, cityError: '' }, addressError: { ...currentResidency.addressError, cityError: ''}, hasError: false }
        stateManager.setCurrentResidency(updatedCurrentResidency)

        validate(3000)
    },
    'Landlord.Wrapper.AddressDetails.State': ({ currentResidency, selectedOptionId }, stateManager) => {
        const updatedCurrentResidency = { ...currentResidency, address: { ...currentResidency.address, state: selectedOptionId, stateError: '' }, addressError: { ...currentResidency.addressError, stateError: ''}, hasError: false }
        stateManager.setCurrentResidency(updatedCurrentResidency)

        validate(3000)
    },
    'Landlord.Wrapper.AddressDetails.Zip': ({ currentResidency, value }, stateManager) => {
        const updatedCurrentResidency = { ...currentResidency, address: { ...currentResidency.address, zip: value, zipError: '' }, addressError: { ...currentResidency.addressError, zipError: ''}, hasError: false }

        stateManager.setCurrentResidency(updatedCurrentResidency)

        validate(3000)
    },
    'Landlord.Wrapper.Address': ({ currentResidency, value }, stateManager) => {
        const updatedCurrentResidency = { ...currentResidency, address: value, addressError: '', hasError: false }
        stateManager.setCurrentResidency(updatedCurrentResidency)

        validate(3000)
    },
    'Landlord.Wrapper.Name': ({ currentResidency, value }, stateManager) => {
        stateManager.setCurrentResidency({ ...currentResidency, name: replaceDoubleSpaceToSingle(value) })

    },
    'Landlord.Wrapper.Number': ({ currentResidency, value }, stateManager) => {
        
        const maskedNum = maskPhoneNum(value)
        const updatedCurrentResidency = { ...currentResidency, number: maskedNum, numberError: '', hasError: false }
        stateManager.setCurrentResidency(updatedCurrentResidency)
        validate(3000)

    },
    'Landlord.Wrapper.Email': ({ currentResidency, value }, stateManager) => {
        const updatedCurrentResidency = { ...currentResidency, email: value.trim(), emailError: '', hasError: false }
        stateManager.setCurrentResidency(updatedCurrentResidency)

        validate(3000)

    },
};
